export default () => ({
  tabPanel: {
    height: 'calc(100% - 50px)',
  },
});
